var _path, _path2, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainListIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 112,
    viewBox: "0 0 99 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7157 8.25213C36.6208 -5.22951 64.863 3.26477 82.7967 27.2247C100.73 51.184 101.564 81.5361 84.6588 95.0181C67.7538 108.499 39.5115 100.005 21.5779 76.0456C3.64447 52.0858 2.81062 21.7337 19.7157 8.25213Z",
    fill: "#DAF727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 15.8584C22.2995 8.86423 33.9492 7.62503 45.5959 11.1279C57.2408 14.6303 68.9559 22.8847 78.0344 35.0137C87.1131 47.1433 91.8855 60.9177 92.2287 73.4111C92.5718 85.8999 88.4827 97.2002 79.7199 104.188C70.9498 111.182 59.3002 112.421 47.6535 108.918C36.0086 105.416 24.2935 97.1622 15.215 85.0332C6.13613 72.9035 1.36291 59.1283 1.01971 46.6348C0.676762 34.1462 4.76681 22.8464 13.5295 15.8584Z",
    fill: "#5235E8",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 40,
    width: 52,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 34,
    transform: "translate(22.2544 47.6428) rotate(-8.46129)",
    fill: "url(#pattern0_1_125)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.2544,
    y: 47.6428,
    width: 47,
    height: 34,
    transform: "rotate(-8.46129 22.2544 47.6428)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_125",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_125",
    transform: "scale(0.0212766 0.0294118)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_125",
    width: 47,
    height: 34,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAiCAMAAAD4Z3BAAAABEVBMVEUAAAAjKS8jKS8jKS8AAAAjKS8jKS8iKzAjKS9AQEAjKS8jKS8iKS8iKS8jKDAjKTAjKS8kKi8jKS8jKS8jKS8cHDkjKS8jKS8jKS8iKTAjKS8jKS8jKS8jKC8zMzMkKS8jKS8jKS8jLi4jKS8jKS4jKTAjKS8jKC8gICAjKS4jLCwkKC8jKi8iKS8cKyskKS8iIjMnJyckKS4hLCwkLCwjKi0iKS8lJTIjKS8iKi8kKS8jKzIjKS8jKS8kKS4jKS8kKTAiKS8kKTAjKjAiKS8nJy4jKS4aMzMjJy8AAFUlJS0uLi4qKioiKC8iKC8hJywgMDAgKDAmJi8lLDIqKiolKi4lKS0iKjAeLS0jKTAjKS5rxan5AAAAW3RSTlMA//L+AfX8NfgEzriUqjqmXqzg+t0JyunXSr6C4pkF7XOLFrrsm/CRCFgdnm54EmQPDY8XI0lpFcM8MSTmfDjaa0SXUHAhhApBAyILBiZSLhAgGykMNz5bEaEsCmFQJgAAAa1JREFUeJzFVGljwUAQ3UhEgjQEdav7KkUppa22VO/7bv//D2lmQuTY4FvfJ/vmmezMvB1ywrpdrlCfOMOvCgR+Oj9xWZZR4ecc1NwFhJmJqDMfAhC+Dl1/DulY+cZA5cPwh1ieJv89hpi3aiLfE0C6R3Z5NwaR1IOFFtN4yS+bvgC0a2hPdAYBPmmuOlPBNAFqXW4IBe1JWEuSBd5SWHV7ycQpKQz49kI46lmcPUU4b+856QmRQRAqzeB3p7UDJ6XnLCeqObBAr5wO4u0YfmuVnJBHvLKOUIBe6xJ17PgcUWonLfgMop8Yppg+2kCuoh3P5nLNKdVP/wHR06iUKs3ryEZqrnY4b0+5dLte/rxraCi7v+4bos80MEZ5Xa33a3NNTHI/pxs4QlsGPs2jY3ymTMvZEwfoN0nfHX2tCCf5KIruvFoywzIwBbp8gDdWTK6Z4a4JdylyDlvjHpvZCE6jqL86HRmtNXYL40CEmpVuYPcuKR/O8hBKmkltGUgUudo2fBFSxkA94et2WgY9LTrQiTquVeWFLifkDndNeVF1VWJcKlaM/l5W4wK/9QfhEx63tirLtAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainListIcon4);
export default __webpack_public_path__ + "static/media/chain-list-icon-4.69164de3e3ec8ce86aa3d9bd2257171d.svg";
export { ForwardRef as ReactComponent };